const LOW_PRIORITY_MODALITIES = Object.freeze([
  'SEG',
  // 'KO',
  // 'PR',
  'SR',
  'RTSTRUCT',
  'DOC',
  'OT',
]);

export default function isLowPriorityModality(Modality) {
  return LOW_PRIORITY_MODALITIES.indexOf(Modality) >= 0;
}
